import React, { useRef } from "react";
import { Helmet } from "react-helmet-async";
import "./Home.css";


import {
FaLaptopCode,
FaCode,
FaBullhorn,
FaSearch,
FaUsers,
FaChartLine,
FaBullseye,
FaChevronDown,
FaBuilding,
FaStar
} from "react-icons/fa";

import digitalHeroImg from "../assets/digital-hero.jpeg";



const Home = () => {

  const portfolioRef = useRef(null);

  const servicesSliderRef = useRef(null);

const scrollServices = (direction) => {

  if (servicesSliderRef.current) {

    const scrollAmount = servicesSliderRef.current.clientWidth;


    servicesSliderRef.current.scrollBy({

      left: direction === "next" ? scrollAmount : -scrollAmount,

      behavior: "smooth"

    });

  }

};


  // ✅ FAQ toggle state

  const services = [
  {
    name: "Web Design",
    icon: <FaLaptopCode />,
    description:
      "Strategic websites designed to build trust, attract customers, and turn online visits into meaningful action.",
    link: "/web-design-kenya/"
  },


  {
    name: "Digital Marketing",
    icon: <FaBullhorn />,
    description:
      "Data-driven marketing strategies that increase visibility, attract qualified leads, and support sustainable sales.",
    link: "/digital-marketing-smes/"
  },

  {
    name: "Social Media Marketing",
    icon: <FaUsers />,
    description:
      "Strategic social media management that builds engagement, strengthens your brand, and creates opportunities for growth.",
    link: "/social-media-management-services/"
  },


  {
  name: "SEO Services",
  icon: <FaSearch />,
  description:
    "Strategic SEO that improves search visibility, attracts the right audience, and creates sustainable business growth.",
  link: "/seo-services-kenya/"
},

  
  {
    name: "Digital Strategy",
    icon: <FaChartLine />,
    description:
      "Clear digital strategies that connect your goals, audience, and online channels into a focused growth plan.",
    link: "/digital-strategy-consultation/"
  },

  {
    name: "Custom Software",
    icon: <FaCode />,
    description:
      "Custom-built software that simplifies operations, automates processes, and helps your business work more efficiently.",
    link: "/custom-software-solutions/"
  }

];



  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>
          Digital Marketing Agency in Nairobi for SMEs | Web Design & Lead Generation Kenya
        </title>

        <link rel="canonical" href="https://satimatechnova.co.ke/" />

        <meta
          name="description"
          content="Affordable digital marketing agency in Nairobi helping small businesses in Kenya generate leads, increase sales, and grow with high-converting websites and data-driven strategies."
        />

        <meta
          name="keywords"
          content="digital marketing agency Kenya, web design Kenya, SEO services Kenya, social media marketing Kenya, online marketing Kenya, Satima Technova Solutions"
        />
        <meta name="author" content="Satima Technova" />

        {/* Open Graph */}
        <meta property="og:title" content="Digital Marketing Agency in Kenya" />
        <meta property="og:description" content="We help Kenyan businesses generate real customers through digital marketing and high-converting websites." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://satimatechnova.co.ke/" />

        {/* Schema Markup */}
        <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://satimatechnova.co.ke/#organization",
  "name": "Satima Technova Solutions",
  "url": "https://satimatechnova.co.ke/",
  "logo": "https://satimatechnova.co.ke/logo.jpeg",
  "image": "https://satimatechnova.co.ke/logo.jpeg",
  "telephone": "+254799090598",
  "sameAs": [
    "https://www.facebook.com/share/1ZEARUmfKZ/",
    "https://www.instagram.com/satimatechnovasolutions/",
    "https://www.linkedin.com/company/107933110/"
  ]
}
`}
</script>


<script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": "https://satimatechnova.co.ke/#business",
  "name": "Satima Technova Solutions",
  "url": "https://satimatechnova.co.ke/",
  "image": "https://satimatechnova.co.ke/logo.jpeg",
  "telephone": "+254799090598",

  "priceRange": "$$",

  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Nairobi",
    "addressRegion": "Nairobi County",
    "postalCode": "00604",
    "addressCountry": "KE"
  },

  "areaServed": {
    "@type": "Country",
    "name": "Kenya"
  },

  "parentOrganization": {
    "@id": "https://satimatechnova.co.ke/#organization"
  },

  "sameAs": [
    "https://www.facebook.com/share/1ZEARUmfKZ/",
    "https://www.instagram.com/satimatechnovasolutions/",
    "https://www.linkedin.com/company/107933110/"
  ]
}
`}
</script>

<script type="application/ld+json">
{`
{
  "@context":"https://schema.org",
  "@type":"WebSite",
  "@id":"https://satimatechnova.co.ke/#website",
  "url":"https://satimatechnova.co.ke/",
  "name":"Satima Technova Solutions",
  "publisher":{
    "@id":"https://satimatechnova.co.ke/#organization"
  },
  "inLanguage":"en"
}
`}
</script>

<script type="application/ld+json">
{`
{
  "@context":"https://schema.org",
  "@type":"WebPage",
  "@id":"https://satimatechnova.co.ke/#webpage",
  "url":"https://satimatechnova.co.ke/",
  "name":"Digital Marketing Agency in Nairobi for SMEs | Web Design & Lead Generation Kenya",
  "isPartOf":{
    "@id":"https://satimatechnova.co.ke/#website"
  },
  "about":{
    "@id":"https://satimatechnova.co.ke/#organization"
  },
  "inLanguage":"en"
}
`}
</script>



        {/* =========================================================
    HOMEPAGE FAQ SCHEMA
========================================================= */}

<script
  type="application/ld+json"
  dangerouslySetInnerHTML={{
    __html: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What does your website design service include?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We design and develop professional, responsive websites built around your business goals and target customers. Depending on your requirements, this can include business websites, landing pages, e-commerce websites, custom functionality, mobile optimization, SEO-friendly structures, and other features your business needs."
          }
        },
        {
          "@type": "Question",
          "name": "How can digital marketing help my business grow?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Digital marketing helps your business reach the right people, build visibility, generate enquiries, and create opportunities online. We combine different digital channels based on your goals, audience, and stage of growth rather than relying on random marketing activities."
          }
        },
        {
          "@type": "Question",
          "name": "Can you manage my business social media?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. We provide social media marketing and management for businesses that want to build a stronger and more consistent presence on platforms such as Facebook and Instagram. Our approach focuses on relevant content, consistent communication, audience engagement, and using social media to support your wider business goals."
          }
        },
        {
          "@type": "Question",
          "name": "How can SEO help my business appear on Google?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "SEO helps improve how your website is understood and discovered by search engines. We work on areas such as website structure, page content, technical performance, keyword relevance, and other SEO fundamentals to improve your visibility for relevant searches. SEO is a long-term process, so results depend on factors such as competition, your industry, and the condition of your website."
          }
        },
        {
          "@type": "Question",
          "name": "Why should my business optimize its Google Business Profile?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A well-optimized Google Business Profile can make it easier for customers searching locally to discover your business and find important information about your services. We help businesses improve their profile information, categories, descriptions, services, content, and overall presence to support stronger local visibility."
          }
        },
        {
          "@type": "Question",
          "name": "Do you provide digital strategy and consultation?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. We provide digital strategy and consultation for businesses that need clarity on what to do next. We assess your current digital presence, identify opportunities and gaps, and help you determine which channels, strategies, and digital solutions make sense for your business. The goal is to help you invest your time and budget in activities that support your actual business objectives."
          }
        }
      ]
    })
  }}
/>


      </Helmet>


     {/* TRUST STRIP */}

<section className="trust-strip">

  <div className="trust-track">

    {[
      {
        icon: <FaBuilding />,
        number: "120+",
        label: "Businesses Served",
      },
      {
        icon: <FaChartLine />,
        number: "2M+",
        label: "Campaign Reach",
      },
      {
        icon: <FaBullseye />,
        number: "15,000+",
        label: "Leads Generated",
      },
      {
        icon: <FaLaptopCode />,
        number: "200+",
        label: "Projects Completed",
      },
      {
        icon: <FaStar />,
        number: "98%",
        label: "Client Satisfaction",
      },
    ]
      .concat([
        {
          icon: <FaBuilding />,
          number: "120+",
          label: "Businesses Served",
        },
        {
          icon: <FaChartLine />,
          number: "2M+",
          label: "Campaign Reach",
        },
        {
          icon: <FaBullseye />,
          number: "15,000+",
          label: "Leads Generated",
        },
        {
          icon: <FaLaptopCode />,
          number: "200+",
          label: "Projects Completed",
        },
        {
          icon: <FaStar />,
          number: "98%",
          label: "Client Satisfaction",
        },
      ])
      .map((item, index) => (

        <div className="trust-card" key={index}>

          <div className="badge-icon">
            {item.icon}
          </div>

          <div className="trust-content">
            <h2>{item.number}</h2>
            <p>{item.label}</p>
          </div>

        </div>

      ))}

  </div>

</section>



<div className="dn-hero-wrapper">

  <section
  className="dn-hero-section"
  style={{
    backgroundImage: `url(${digitalHeroImg})`
  }}
>

  <div className="dn-hero-overlay">

    <div className="dn-hero-content">

      <p className="dn-hero-badge">
        Trusted Digital Solutions Partner
      </p>

      <h1 className="dn-hero-title">
        Digital Growth
        <br />
        With Direction.
      </h1>

      <p className="dn-hero-subtitle">
        We build powerful digital solutions that help ambitious businesses
        attract customers, strengthen their brands, and grow online.
      </p>

      <div className="dn-hero-actions">

        <a
  href="https://booking.satimatechnova.co.ke"
  className="dn-btn dn-btn-secondary"
>
  Book Our Services
</a>

        <a
          href="#services"
          className="dn-btn dn-btn-secondary"
        >
          View Our Services
        </a>

      </div>

      <div className="dn-hero-trust">

        <span>
          ✔ Lead-focused strategies
        </span>

        <span>
          ✔ Modern websites that convert
        </span>

        <span>
          ✔ Ongoing support & optimization
        </span>

      </div>

    </div>

  </div>

</section>
</div>



{/* =========================================================
    DIGITAL GROWTH GAP
========================================================= */}

<section id="fomo" className="dn-fomo-section">

  <div className="dn-fomo-container">

    {/* SECTION HEADER */}

    <div className="dn-fomo-header">

      <span className="dn-fomo-kicker">
        THE DIGITAL GROWTH GAP
      </span>

      <h2 className="dn-fomo-title">
        Being online is no longer enough.
        <br />
        <span>Being effective is.</span>
      </h2>

      <p className="dn-fomo-intro">
        Businesses that approach their digital presence strategically
        are better positioned to attract attention, build trust, and
        turn online visibility into real business opportunities.
      </p>

    </div>


    {/* MAIN CONTENT */}

    <div className="dn-fomo-grid">

      {/* CHALLENGE */}

      <div className="dn-fomo-card dn-fomo-bad">

        <div className="dn-fomo-card-top">
          <span className="dn-fomo-number">
            01
          </span>

          <span className="dn-fomo-card-label">
            WITHOUT DIRECTION
          </span>
        </div>

        <h3>
          Digital activity without a strategy
        </h3>

        <p className="dn-fomo-card-intro">
          Being present online does not automatically create growth.
          Without the right structure, businesses often experience:
        </p>

        <ul>
          <li>Poor online visibility</li>
          <li>Inconsistent customer engagement</li>
          <li>Weak brand positioning</li>
          <li>Unpredictable lead generation</li>
          <li>Outdated digital experiences</li>
          <li>Marketing that feels disconnected</li>
        </ul>

      </div>


      {/* SATIMA APPROACH */}

      <div className="dn-fomo-card dn-fomo-good">

        <div className="dn-fomo-card-top">
          <span className="dn-fomo-number">
            02
          </span>

          <span className="dn-fomo-card-label">
            WITH SATIMA
          </span>
        </div>

        <h3>
          Digital growth with direction
        </h3>

        <p className="dn-fomo-card-intro">
          We bring strategy, creativity, technology, and execution
          together to build a digital presence designed around your
          actual business goals.
        </p>

        <div className="dn-fomo-points">

          <div className="dn-fomo-point">
            <span>01</span>
            <p>Clear digital strategy</p>
          </div>

          <div className="dn-fomo-point">
            <span>02</span>
            <p>Modern digital experiences</p>
          </div>

          <div className="dn-fomo-point">
            <span>03</span>
            <p>Consistent marketing execution</p>
          </div>

          <div className="dn-fomo-point">
            <span>04</span>
            <p>Continuous measurement and improvement</p>
          </div>

        </div>

        <a
          href="https://wa.me/254775137928?text=Hello%2C%20I%20would%20like%20help%20improving%20my%20online%20presence%20and%20growing%20my%20business.%20Kindly%20share%20more%20details."
          className="dn-fomo-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Start With Strategy
        </a>

      </div>

    </div>


    {/* CLOSING STATEMENT */}

    <div className="dn-fomo-bottom">

      <span className="dn-fomo-bottom-line"></span>

      <p>
        Your competitors don't necessarily have better businesses.
        They may simply have a better digital system.
      </p>

    </div>

  </div>

</section>



      
     {/* =========================================================
    DIGITAL GROWTH SERVICES
========================================================= */}

<section id="services" className="st-services-section">

  <div className="st-services-container">

    {/* HEADER */}

    <div className="st-services-header">

      <span className="st-services-label">
        WHAT WE DO
      </span>

      <h2>
        Digital Solutions
        <br />
        <span>Built With Purpose.</span>
      </h2>

      <p>
        From websites to digital marketing, we create practical
        solutions designed around your business goals and customers.
      </p>

    </div>


    {/* SERVICES */}

    <div
      className="st-services-grid"
      ref={servicesSliderRef}
    >

      {services.map((service, index) => (

        <article
          className="st-service-card"
          key={index}
        >

          <div className="st-service-top">

            <span className="st-service-number">
              {String(index + 1).padStart(2, "0")}
            </span>

            <div className="st-service-icon">
              {service.icon}
            </div>

          </div>


          <div className="st-service-content">

            <h3>
              {service.name}
            </h3>

            <p>
              {service.description}
            </p>

          </div>


          <a
            href={service.link}
            className="st-service-link"
          >
            <span>Discover More</span>
            <span className="st-service-arrow">→</span>
          </a>

        </article>

      ))}

    </div>


    {/* MOBILE / SLIDER NAVIGATION */}

    <div className="st-services-navigation">

      <button
        onClick={() => scrollServices("prev")}
        aria-label="Previous service"
      >
        ←
      </button>

      <span>
        EXPLORE SERVICES
      </span>

      <button
        onClick={() => scrollServices("next")}
        aria-label="Next service"
      >
        →
      </button>

    </div>

  </div>

</section>


      
{/* =========================================================
    WHY BUSINESSES CHOOSE SATIMA
========================================================= */}

<section className="home-why-section">

  <div className="home-why-container">

    <div className="home-why-header">

      <span className="home-why-label">
        WHY BUSINESSES CHOOSE SATIMA
      </span>

      <h2>
        Built Around Your
        <br />
        Business.
      </h2>

      <p>
        We bring strategy, technology, and digital execution together
        to create solutions that make sense for your business.
      </p>

    </div>


    <div className="home-why-card">

      <div className="home-why-accent"></div>

      <div className="home-why-content">


        {/* LEFT STATEMENT */}

        <div className="home-why-statement">

          <span className="home-why-quote">
            “
          </span>

          <h3>
            Digital.
            <br />
            <span>With Direction.</span>
          </h3>

        </div>


        {/* RIGHT MESSAGE */}

        <div className="home-why-message">

          <p>
            We believe businesses need more than
            <strong> disconnected digital services.</strong>
            They need a partner who understands the bigger picture
            and builds around what they are trying to achieve.
          </p>


          <div className="home-why-principles">


            {/* PRINCIPLE 01 */}

            <div className="home-why-principle">

              <span className="home-why-number">
                01
              </span>

              <div>

                <h4>
                  SME Focused
                </h4>

                <p>
                  We understand the realities of Kenyan businesses
                  and build around your goals, customers, and opportunities.
                </p>

              </div>

            </div>


            {/* PRINCIPLE 02 */}

            <div className="home-why-principle">

              <span className="home-why-number">
                02
              </span>

              <div>

                <h4>
                  Connected Solutions
                </h4>

                <p>
                  Websites, marketing, content, social media, and
                  technology work together instead of operating separately.
                </p>

              </div>

            </div>


            {/* PRINCIPLE 03 */}

            <div className="home-why-principle">

              <span className="home-why-number">
                03
              </span>

              <div>

                <h4>
                  Business Focused
                </h4>

                <p>
                  Every solution is shaped around your objectives,
                  audience, resources, and the action you want to create.
                </p>

              </div>

            </div>


          </div>


          {/* CLOSING STATEMENT */}

          <div className="home-why-highlight">

            <span className="home-why-highlight-line"></span>

            <p>
              You don't need
              <strong> more digital activity.</strong>
              You need digital work that moves your business forward.
            </p>

          </div>


        </div>

      </div>

    </div>

  </div>

</section>


{/* =========================================================
    WEBSITE PORTFOLIO SECTION
========================================================= */}

<section className="portfolio-section">

  <div className="portfolio-header">

    <span className="portfolio-label">
      OUR PORTFOLIO
    </span>

    <p>
      Explore some of the websites we have created for businesses
      and brands looking to establish a stronger online presence.
    </p>

  </div>


  <div
    className="portfolio-grid"
    ref={portfolioRef}
  >


    {/* =====================================================
        MWANGAZA WELLNESS
    ===================================================== */}

    <div className="portfolio-card">

      <span className="portfolio-category">
        HEALTH & WELLNESS WEBSITE
      </span>

      <h3>
        Mwangaza Wellness
      </h3>

      <p>
        A professional wellness website designed to communicate
        services, build credibility, and create a trusted online presence.
      </p>

      <a
        href="https://mwangazawellness.co.ke"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-btn"
      >
        Preview Site
      </a>

    </div>


    {/* =====================================================
        EMMIE GIFTS
    ===================================================== */}

    <div className="portfolio-card">

      <span className="portfolio-category">
        E-COMMERCE WEBSITE
      </span>

      <h3>
        Emmie Gift Shop
      </h3>

      <p>
        An elegant online shopping platform created to showcase
        products and provide customers with a smooth browsing experience.
      </p>

      <a
        href="https://emmiegiftshop.co.ke"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-btn"
      >
        Preview Site
      </a>

    </div>


    {/* =====================================================
        POSITIVE CORRELATION
    ===================================================== */}

    <div className="portfolio-card">

      <span className="portfolio-category">
        BUSINESS WEBSITE
      </span>

      <h3>
        Positive Correlation
      </h3>

      <p>
        A modern business website developed to strengthen brand
        visibility and communicate services professionally.
      </p>

      <a
        href="https://positivecorrelation.com"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-btn"
      >
        Preview Site
      </a>

    </div>


    {/* =====================================================
        STREET SMART RECRUITERS
    ===================================================== */}

    <div className="portfolio-card">

      <span className="portfolio-category">
        RECRUITMENT WEBSITE
      </span>

      <h3>
        Street Smart Recruiters
      </h3>

      <p>
        A recruitment platform designed to connect businesses
        and candidates through a professional online presence.
      </p>

      <a
        href="https://streetsmartrecruiters.co.ke"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-btn"
      >
        Preview Site
      </a>

    </div>


    {/* =====================================================
        BLOOMCART
    ===================================================== */}

    <div className="portfolio-card">

      <span className="portfolio-category">
        E-COMMERCE PLATFORM
      </span>

      <h3>
        BloomCart Kenya
      </h3>

      <p>
        A complete e-commerce solution designed to help customers
        browse products and enjoy a seamless shopping experience.
      </p>

      <a
        href="https://bloomcartke.co.ke"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-btn"
      >
        Preview Site
      </a>

    </div>


  </div>


  {/* =====================================================
      MOBILE PORTFOLIO ARROWS
  ===================================================== */}

  <div className="portfolio-arrows">

    <button
      aria-label="Previous portfolio"
      onClick={() =>
        portfolioRef.current &&
        portfolioRef.current.scrollBy({
          left: -320,
          behavior: "smooth"
        })
      }
    >
      ‹
    </button>


    <button
      aria-label="Next portfolio"
      onClick={() =>
        portfolioRef.current &&
        portfolioRef.current.scrollBy({
          left: 320,
          behavior: "smooth"
        })
      }
    >
      ›
    </button>

  </div>


</section>

      

      {/* =========================================================
    HOMEPAGE FAQ SECTION
========================================================= */}

<section className="home-faq-section">


  <div className="home-faq-header">

    <span className="home-faq-label">
      FREQUENTLY ASKED QUESTIONS
    </span>

    <p>
      Find answers to common questions about our digital services and how
      Satima can help your business build visibility, attract customers,
      and grow online.
    </p>

  </div>




  <div className="home-faq-container">


    {/* =====================================================
        FAQ 1 — WEBSITE DESIGN
    ===================================================== */}

    <div className="home-faq-item">

      <details>

        <summary>

          What does your website design service include?

          <FaChevronDown />

        </summary>


        <p>
          We design and develop professional, responsive websites built
          around your business goals and target customers.

          <br /><br />

          Depending on your requirements, this can include business
          websites, landing pages, e-commerce websites, custom functionality,
          mobile optimization, SEO-friendly structures, and other features
          your business needs.

        </p>


      </details>

    </div>




    {/* =====================================================
        FAQ 2 — DIGITAL MARKETING
    ===================================================== */}

    <div className="home-faq-item">

      <details>

        <summary>

          How can digital marketing help my business grow?

          <FaChevronDown />

        </summary>


        <p>
          Digital marketing helps your business reach the right people,
          build visibility, generate enquiries, and create opportunities
          online.

          <br /><br />

          We combine different digital channels based on your goals,
          audience, and stage of growth rather than relying on random
          marketing activities.

        </p>


      </details>

    </div>




    {/* =====================================================
        FAQ 3 — SOCIAL MEDIA MARKETING
    ===================================================== */}

    <div className="home-faq-item">

      <details>

        <summary>

          Can you manage my business social media?

          <FaChevronDown />

        </summary>


        <p>
          Yes. We provide social media marketing and management for
          businesses that want to build a stronger and more consistent
          presence on platforms such as Facebook and Instagram.

          <br /><br />

          Our approach focuses on relevant content, consistent communication,
          audience engagement, and using social media to support your wider
          business goals.

        </p>


      </details>

    </div>




    {/* =====================================================
        FAQ 4 — SEO
    ===================================================== */}

    <div className="home-faq-item">

      <details>

        <summary>

          How can SEO help my business appear on Google?

          <FaChevronDown />

        </summary>


        <p>
          SEO helps improve how your website is understood and discovered
          by search engines.

          <br /><br />

          We work on areas such as website structure, page content,
          technical performance, keyword relevance, and other SEO
          fundamentals to improve your visibility for relevant searches.

          <br /><br />

          SEO is a long-term process, so results depend on factors such as
          competition, your industry, and the condition of your website.

        </p>


      </details>

    </div>




    {/* =====================================================
        FAQ 5 — GOOGLE BUSINESS PROFILE
    ===================================================== */}

    <div className="home-faq-item">

      <details>

        <summary>

          Why should my business optimize its Google Business Profile?

          <FaChevronDown />

        </summary>


        <p>
          A well-optimized Google Business Profile can make it easier for
          customers searching locally to discover your business and find
          important information about your services.

          <br /><br />

          We help businesses improve their profile information, categories,
          descriptions, services, content, and overall presence to support
          stronger local visibility.

        </p>


      </details>

    </div>




    {/* =====================================================
        FAQ 6 — DIGITAL STRATEGY & CONSULTATION
    ===================================================== */}

    <div className="home-faq-item">

      <details>

        <summary>

          Do you provide digital strategy and consultation?

          <FaChevronDown />

        </summary>


        <p>
          Yes. We provide digital strategy and consultation for businesses
          that need clarity on what to do next.

          <br /><br />

          We assess your current digital presence, identify opportunities
          and gaps, and help you determine which channels, strategies, and
          digital solutions make sense for your business.

          <br /><br />

          The goal is to help you invest your time and budget in activities
          that support your actual business objectives.

        </p>


      </details>

    </div>


  </div>


</section>


{/* PREMIUM HOME CTA */}

<section className="final-cta-section1">

  <div className="final-cta-content1">

    <span className="final-cta-label1">
      READY TO GROW?
    </span>

    <h2>
      Your Business Deserves
      <br />
      <span>A Digital Presence That Works.</span>
    </h2>

    <p>
      Let's build the right digital foundation to attract customers,
      strengthen your brand, and move your business forward.
    </p>

    <a
      href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I'm%20interested%20in%20growing%20my%20business%20online."
      target="_blank"
      rel="noopener noreferrer"
      className="final-cta-btn1"
    >
      Start Your Growth Journey
      <span>→</span>
    </a>

  </div>

</section>



    </>
  );
};

export default Home;